import { memo, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

import { Switch } from 'basic-components';

// eslint-disable-next-line
const Boolean = ({ value, onChange, menuPosition, ref, ...props }) => {

  useImperativeHandle(ref, () => ({
    isValid: () => true,
    validateForForm: () => true
  }))
  return (
    <Switch
        {...props}
        on={value !== "" && value !== false && value !== "false" && value !== null && value !== undefined}
        onChange={onChange}
    />
  )
}

Boolean.displayName = "Boolean"

Boolean.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired 
}

export default memo(Boolean);